import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "profile-creation-wizard ff-bottom-fixed-cta" }
const _hoisted_2 = { class: "profile-creation-wizard__container" }
const _hoisted_3 = { class: "profile-creation-wizard__content-footer" }

import {useRouter} from 'vue-router';
    import {computed} from 'vue';
    import StepMobileHeader from '@/profile-creation-wizard/common/ui/step/StepMobileHeader.vue';
    import StepActions from '@/profile-creation-wizard/common/ui/step/StepActions.vue';
    import {CreationStepName} from '@/profile-creation-wizard/config/steps/ProfileCreationSteps';

    export interface Props {
        progressBar?: boolean;
        showStepper?: boolean;
        isStepValid?: boolean;
        showSkipStep?: boolean;
        isSkipEnabled?: boolean;
        isLoading?: boolean;
        fullScreen?: boolean;
        showButtons?: boolean;
    }
    
export default /*@__PURE__*/_defineComponent({
  __name: 'Step',
  props: {
    progressBar: { type: Boolean, default: true },
    showStepper: { type: Boolean, default: true },
    isStepValid: { type: Boolean, default: false },
    showSkipStep: { type: Boolean, default: false },
    isSkipEnabled: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    fullScreen: { type: Boolean, default: false },
    showButtons: { type: Boolean, default: true }
  },
  emits: ['go-to-next'],
  setup(__props: any, { emit: __emit }) {

    const router = useRouter();

    const meta = computed(() => router.currentRoute.value.meta);
    const hasPreviousStep = computed(() => meta.value.previousStep !== null);
    const progressPercentage = computed(() => meta.value.progressPercentage);
    const isLastStep = computed(() => meta.value.nextStep === null);
    const isIntroductionStep = computed(() => router.currentRoute.value.name === CreationStepName.SIGNUP_INTRODUCTION);

    const props = __props;

    const emits = __emit;

    function goNext() {
        emits('go-to-next');
    }

    function goToPrevious() {
        if (hasPreviousStep.value) {
            router.push({name: meta.value.previousStep});
        }
    }

return (_ctx: any,_cache: any) => {
  const _component_VJoyProgressBar = _resolveComponent("VJoyProgressBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.progressBar)
      ? (_openBlock(), _createBlock(_component_VJoyProgressBar, {
          key: 0,
          percentage: progressPercentage.value
        }, null, 8, ["percentage"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["profile-creation-wizard__content-actions", {fullscreen: _ctx.fullScreen}])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["profile-creation-wizard__content", {'introduction-step': isIntroductionStep.value}])
        }, [
          _createVNode(StepMobileHeader, {
            "show-button-previous": hasPreviousStep.value,
            "onClick:previous": goToPrevious
          }, null, 8, ["show-button-previous"]),
          _renderSlot(_ctx.$slots, "step-content")
        ], 2),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.progressBar)
            ? (_openBlock(), _createBlock(_component_VJoyProgressBar, {
                key: 0,
                percentage: progressPercentage.value,
                color: "primary"
              }, null, 8, ["percentage"]))
            : _createCommentVNode("", true),
          (_ctx.showStepper)
            ? (_openBlock(), _createBlock(StepActions, {
                key: 1,
                "is-disabled-button-next": !_ctx.isStepValid || _ctx.isSkipEnabled,
                "is-disabled-button-skip": !_ctx.isSkipEnabled,
                "is-disabled-button-finish": !_ctx.isStepValid || _ctx.isSkipEnabled,
                "is-loading-button-next": _ctx.isLoading,
                "is-loading-button-finish": _ctx.isLoading,
                "show-button-previous": hasPreviousStep.value,
                "show-button-skip": _ctx.showSkipStep && _ctx.showButtons,
                "show-button-next": !isLastStep.value && _ctx.showButtons,
                "show-button-finish": isLastStep.value && _ctx.showButtons,
                "onClick:next": goNext,
                "onClick:skip": goNext,
                "onClick:finish": goNext,
                "onClick:previous": goToPrevious
              }, null, 8, ["is-disabled-button-next", "is-disabled-button-skip", "is-disabled-button-finish", "is-loading-button-next", "is-loading-button-finish", "show-button-previous", "show-button-skip", "show-button-next", "show-button-finish"]))
            : _createCommentVNode("", true)
        ])
      ], 2),
      _renderSlot(_ctx.$slots, "step-side")
    ]),
    _renderSlot(_ctx.$slots, "step-dialog")
  ]))
}
}

})